import { render, staticRenderFns } from "./AuthSelect.vue?vue&type=template&id=5a640041&scoped=true"
import script from "./AuthSelect.vue?vue&type=script&lang=js"
export * from "./AuthSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a640041",
  null
  
)

export default component.exports